import { sellerConstants } from '../../_constants/seller.constants';
import swal from 'sweetalert2/dist/sweetalert2.min.js';


const initialState = { revokeCreditsLoading: true, data: '', error: false, errorText: '' };

export function revokeCredit(state = initialState, action) {
    switch (action.type) {
        case sellerConstants.REQUEST_REVOKE_CREDITS:
            return {
                revokeCreditsLoading: true,
                data: '',
                error: false,
                errorText: ''
            };
        case sellerConstants.RECEIVE_REVOKE_CREDITS:
        swal({
            text: "Credits Revoked Successfully!",
            type:"success",
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
        })
            return {
                revokeCreditsLoading: false,
                data: action.data,
                error: false,
                errorText: ''
            };
        case sellerConstants.REVOKE_CREDITS_ERROR:
            swal({
                type: "error",
                text: action.error.response.data.message,
            });
           
            return {
                revokeCreditsLoading: false,
                data: action.error,
                error: true,
                errorText: action.error
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/revokeCredit.reducer.js